import ClassificationViewState from '../store/schema/ClassificationViewState';
import MessageClassificationType from 'owa-service/lib/contract/MessageClassificationType';
import classifyMessage from './classifyMessage';
import clearClassification from './clearClassification';
import { InfoBarHostViewState } from 'owa-info-bar/lib/schema/InfoBarMessageViewState';

export default function getMessageClassificationContextMenuItemProps(
    classification: MessageClassificationType,
    viewState: ClassificationViewState,
    infoBarViewState: InfoBarHostViewState,
    onClearIrmData: () => void
) {
    const { Id, Name } = classification;
    const { messageClassification } = viewState;
    const isSelectedMessageClassification =
        messageClassification && messageClassification.Id === Id;
    return {
        name: Name,
        key: Id,
        onClick: () => {
            onClearIrmData();
            if (!isSelectedMessageClassification) {
                classifyMessage(viewState, infoBarViewState, classification);
            } else {
                clearClassification(viewState, infoBarViewState);
            }
        },
        canCheck: true,
        checked: isSelectedMessageClassification,
    };
}
